import listenerMiddleware from "App/listenerMiddleware";
import { actionTypes as signalRActionTypes } from "Areas/SharedFeatures/signalRMiddleware";
import sidebarDocumentsActionTypes from "Areas/Sidebar/Documents/redux/actionTypes";
import { Permissions, security } from "Common/permissions";
import createReducer from "Common/reducerUtils/createReducer";
import set from "Common/reducerUtils/set";
import includes from "lodash/includes";
import omit from "lodash/omit";
import actionCreators from "./actionCreators";
import actionTypes from "./actionTypes";
import { getSelectedDocumentIds, getTasksLogSocketDataForDocument } from "./selectors";
export const initialState = {
    tasksLogData: {},
    tasksLogSocketData: {},
    logLevels: {},
    presentationInterval: undefined,
    timelineInterval: undefined
};
export default createReducer(initialState, {
    [actionTypes.SET_TASKS_LOGS_DATA]: (state, { items, documentId }) => !items
        ? set(state, "tasksLogData", omit(state.tasksLogData, documentId))
        : set(state, `tasksLogData[${documentId}]`, items),
    [actionTypes.SET_TASKS_LOGS_SOCKET_DATA]: (state, { items, documentId }) => !items
        ? set(state, "tasksLogSocketData", omit(state.tasksLogSocketData, documentId))
        : set(state, `tasksLogSocketData[${documentId}]`, items),
    [actionTypes.SET_LOG_LEVELS]: (state, { logLevels, documentId }) => !logLevels
        ? set(state, "logLevels", omit(state.logLevels, documentId))
        : set(state, `logLevels[${documentId}]`, logLevels),
    [actionTypes.SET_PRESENTATION_INTERVAL]: (state, { interval }) => set(state, "presentationInterval", interval),
    [actionTypes.SET_TIMELINE_INTERVAL]: (state, { interval }) => set(state, "timelineInterval", interval),
    [actionTypes.GET_TASKS_LOGS_DATA_FOR_DOCUMENT_COMPLETED]: (state, { payload, meta: { documentId } }) => {
        const items = state.tasksLogData[documentId] || [];
        return set(state, `tasksLogData[${documentId}]`, [...payload, ...items]);
    }
});
const canViewTasksLogs = security.isAllowed([Permissions.TasksView]);
listenerMiddleware.addListener({
    [signalRActionTypes.TASK_LOG_ITEM_ADDED.redux]: ({ message }, dispatch, getState) => {
        if (!message.documentId || !canViewTasksLogs)
            return;
        const state = getState();
        const selectedDocumentIds = getSelectedDocumentIds(getState());
        if (includes(selectedDocumentIds, message.documentId)) {
            const result = {
                DateTime: message.dateTime || "",
                Message: message.message || "",
                LogLevel: message.logLevel
            };
            const items = getTasksLogSocketDataForDocument(state, message.documentId);
            dispatch(actionCreators.setTasksLogsSocketData([...(items || []), result], message.documentId));
        }
    },
    [sidebarDocumentsActionTypes.SET_DOCUMENT_SELECTED]: ({ documentId, selected }, dispatch) => {
        if (!selected && documentId) {
            dispatch(actionCreators.setTasksLogsData(undefined, documentId));
            dispatch(actionCreators.setTasksLogsSocketData(undefined, documentId));
            dispatch(actionCreators.setLogLevels(undefined, documentId));
        }
    }
});
